import { useEffect, useState } from 'react';
import { usePlatform, useIsMobile } from '../../hooks/usePlatform';
import { useLocation } from 'react-router-dom';
import { RiGooglePlayFill, RiAppleFill, RiNotification3Line, RiCamera2Line, RiChat3Line } from 'react-icons/ri';
import logo from '../../assets/logo.png';
import './DownloadAppPrompt.scss';

const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.blizu.app';
const IOS_APP_URL = 'https://apps.apple.com/mx/app/blizu/idXXXXXXXXXX';
const WEB_HOME_URL = 'https://blizu.com.mx/';

const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

const isAndroid = () => {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent);
};

const VENDOR_ADMIN_ROUTES = [
  '/login',
  '/olvide',
  '/registrarse/vendedor',
  '/registrarse/comprador',
  '/dashboard',
  '/admin',
  '/creartienda',
  '/tipo',
];

const DownloadAppPrompt = () => {
  const { isNative } = usePlatform();
  const isMobile = useIsMobile(768);
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isNative) { setVisible(false); return; }
    if (!isMobile) { setVisible(false); return; }
    const matches = VENDOR_ADMIN_ROUTES.some(
      (route) => pathname === route || pathname.startsWith(route + '/')
    );
    setVisible(matches);
  }, [isNative, isMobile, pathname]);

  const handleAccept = () => {
    window.location.href = WEB_HOME_URL;
  };

  if (!visible) return null;

  const android = isAndroid();
  const ios = isIOS();

  return (
    <div className="download-app-overlay" role="dialog" aria-modal="true">
      <div className="download-app-card">
        <img src={logo} alt="Blizu" className="download-app-logo" />

        <h2 className="download-app-title">Iniciá sesión en la app</h2>
        <p className="download-app-subtitle">
          Ingresá tus credenciales para continuar
        </p>

        <div className="download-app-features">
          <div className="download-app-feature">
            <RiNotification3Line className="icon" />
            <span>Notificaciones de pedidos en tiempo real</span>
          </div>
          <div className="download-app-feature">
            <RiCamera2Line className="icon" />
            <span>Subí fotos directo desde la cámara</span>
          </div>
          <div className="download-app-feature">
            <RiChat3Line className="icon" />
            <span>Chat con tus clientes al instante</span>
          </div>
        </div>

        <div className="download-app-buttons">
          {android && (
            <a
              href={ANDROID_APP_URL}
              className="download-app-btn download-app-btn-primary"
            >
              <RiGooglePlayFill size={20} /> Descargar para Android
            </a>
          )}
          {ios && (
            <a
              href={IOS_APP_URL}
              className="download-app-btn download-app-btn-primary"
            >
              <RiAppleFill size={20} /> Descargar para iOS
            </a>
          )}
          {!android && !ios && (
            <>
              <a
                href={ANDROID_APP_URL}
                className="download-app-btn download-app-btn-primary"
              >
                <RiGooglePlayFill size={20} /> Descargar para Android
              </a>
              <a
                href={IOS_APP_URL}
                className="download-app-btn download-app-btn-secondary"
              >
                <RiAppleFill size={20} /> Descargar para iOS
              </a>
            </>
          )}

          <button
            type="button"
            className="download-app-btn download-app-btn-secondary"
            onClick={handleAccept}
          >
            Aceptar y volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppPrompt;
